import { atom } from "jotai";

export const voyageChecklistTabLabels = {
  preVoyagePlan: "Pre Voyage Plan",
  voyageToLoadPort: "Voyage to Load Port",
  atLoadPort: "At Load Port",
  voyageToDischargePort: "Voyage to Discharge Port",
  atDischargePort: "At Discharge Port",
} as const;

export type VoyageChecklistTabLabel = (typeof voyageChecklistTabLabels)[keyof typeof voyageChecklistTabLabels];

type ChecklistCount = {
  checked: number;
  total: number;
};

const defaultChecklistCounts: Record<VoyageChecklistTabLabel, ChecklistCount> = {
  [voyageChecklistTabLabels.preVoyagePlan]: { checked: 0, total: 0 },
  [voyageChecklistTabLabels.voyageToLoadPort]: { checked: 0, total: 0 },
  [voyageChecklistTabLabels.atLoadPort]: { checked: 0, total: 0 },
  [voyageChecklistTabLabels.voyageToDischargePort]: { checked: 0, total: 0 },
  [voyageChecklistTabLabels.atDischargePort]: { checked: 0, total: 0 },
};

export const voyageChecklistCountsAtom = atom(defaultChecklistCounts);

export const updateVoyageChecklistCountAtom = atom(
  null,
  (get, set, payload: { tab: VoyageChecklistTabLabel; checked: number; total: number }) => {
    set(voyageChecklistCountsAtom, {
      ...get(voyageChecklistCountsAtom),
      [payload.tab]: { checked: payload.checked, total: payload.total },
    });
  },
);
